<template>
  <section>
    <div class="card">
      <div class="card-header">{{ $t('message.menu.edit_profile') }}</div>
      <div class="card-body px-1">
        
        <div class="row">
          <div class="col-12">
            <label>{{ $t('message.profile.email') }}:</label> {{ user.email }}
          </div>  
          <div class="col-12" v-if="user && user.platform">
            <label>{{ $t('message.profile.registeredMethod') }}:</label> {{ user.platform }}
          </div>
          <div class="col-12">
            <hr>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-2">{{ $t('message.profile.picture') }}:</label>
          <div class="col-sm-10">
            <img :src="user.picture" class="img-fluid rounded-circle" width="160"><br>
            <vue-core-image-upload
              extensions="png,jpeg,jpg"
              class="btn btn-secondary mt-3"
              :crop="false"
              @imageuploaded="imageUploaded"
              @imageuploading="imageUploading"
              @errorhandle="errorHandle"
              :max-file-size="5242880"
              :headers="headers"
              :credentials="false"
              :url="url"
              :disabled="uploading"
              :text="$t(isUploading)"/>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label class="" for="firstName">{{ $t('message.profile.firstname') }}:</label>
              <input type="text"
                      ref="firstName"
                      class="form-control"
                      :class="{'form-alert': errors.has('firstName')}"
                      id="firstName"
                      name="firstName"
                      v-model="formData.firstName"
                      v-validate="'required'">
              <div class="mt-2 text-remark -status-alert" v-if="errors.has('firstName')">
                {{ $t('message.required_field') }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label class="" for="lastName">{{ $t('message.profile.lastname') }}:</label>
              <input type="text"
                      ref="lastName"
                      class="form-control"
                      :class="{'form-alert': errors.has('firstName')}"
                      id="lastName"
                      name="lastName"
                      v-model="formData.lastName"
                      v-validate="'required'">
              <div class="mt-2 text-remark -status-alert" v-if="errors.has('lastName')">
                {{ $t('message.required_field') }}
              </div>
            </div>
          </div>
        </div>
        <!-- /.end row -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="" for="tel">{{ $t('message.profile.phone') }}:</label>
              <input type="tel"
                      ref="tel"
                      class="form-control"
                      :class="{'form-alert': errors.has('tel')}"
                      id="tel"
                      name="tel"
                      v-model="formData.tel"
                      v-validate="{ required: true, min: 10, max: 15, regex: /^\+?[0-9-]+$/ }">
              <div class="mt-2 text-remark -status-alert" v-if="errors.has('tel')">
                {{ $t('message.required_field') }}
              </div>
            </div>
          </div>
        </div>
      
        <div class="row">
          <div class="col">
            <button class="btn btn-info btn-block"
                    :disabled="userState.isUpdating"
                    @click="saveUserData">{{ $t(isUpdating) }}
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="card">
      <div class="card-header">{{ $t('message.delete_account.title') }}</div>
      <div class="card-body">
        <router-link to="/delete-account"
                     class="btn btn-outline-danger">
          {{ $t('message.delete_account.title') }}
        </router-link>
      </div>
    </div>

  </section>
</template>

<script>
  import { parse, format } from 'libphonenumber-js'
  import { mapGetters, mapActions } from 'vuex'
  import i18n from '../../helpers/i18nHelpers'
  import VueCoreImageUpload from 'vue-core-image-upload'

  export default {
    components: {
      VueCoreImageUpload
    },
    data () {
      return {
        url: '',
        headers: null,
        uploading: false,
        formData: {
          firstName: null,
          lastName: null,
          tel: null
        }
      }
    },
    computed: {
      ...mapGetters({
        isUpdating: 'user/getIsUpdating',
        state: 'auth/getState',
        user: 'auth/getUser',
        userData: 'user/getUserData',
        userState: 'user/getState'
      }),
      isUploading () {
        return (this.uploading) ? 'message.button.uploading' : 'message.button.upload_picture'
      }
    },
    watch: {
      userData () {
        if (this.userData) {
          this.formData.firstName = this.userData.firstName
          this.formData.lastName = this.userData.lastName
          this.formData.tel = this.userData.tel
        }
      },
      isUpdating () {
        if (!this.userState.isUpdating) {
          // Update new name in local
          const name = this.$refs.firstName.value + ' ' + this.$refs.lastName.value
          const data = {key: 'name', value: name}
          this.$store.commit('auth/UPDATE_USER_DATA', data)
          this.updateUserDatainLocalStorage()
          this.$swal({text: i18n.t('message.profile.profile_up_to_date'), type: 'success'})
        }
      }
    },
    methods: {
      ...mapActions('user', ['saveUserProfile']),
      saveUserData () {
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            this.formatPhoneNumber()
            const submitData = {
              user_id: this.user.id,
              first_name: this.$refs.firstName.value,
              last_name: this.$refs.lastName.value,
              tel: this.$refs.tel.value
            }
            await this.saveUserProfile(submitData)
          }
        })
      },
      imageUploaded (res) {
        this.uploading = false
        if (!res.error) {
          const data = {key: 'picture', value: res.image_url}
          this.$store.commit('auth/UPDATE_USER_DATA', data)
          this.updateUserDatainLocalStorage()
        }
      },
      imageUploading (res) {
        this.uploading = true
      },
      errorHandle (res) {
        switch (res) {
          case 'TYPE ERROR':
            this.$swal(i18n.t('message.alert.wrong_picture_format'))
            break
          case 'FILE IS TOO LARGER MAX FILE IS 5.00MB':
            this.$swal(i18n.t('message.alert.over_file_size'))
            break
        }
      },
      updateUserDatainLocalStorage () {
        // Save user and token to local storage as well
        window.localStorage.setItem('user', JSON.stringify(this.user))
      },
      formatPhoneNumber () {
        const tel = this.$refs.tel.value
        if (tel && tel.substring(0, 1) === '0') {
          const parsed = parse(tel, 'TH')
          const phone = format(parsed.phone, 'TH', 'International')
          this.formData.tel = phone.replace(/ /g, '')
          this.$refs.tel.value = this.formData.tel
        }
      }
    },
    mounted () {
      this.$store.dispatch('user/LOAD_USER_PROFILE', this.user.id)
      this.url = this.$http.options.root + '/users/' + this.user.id + '/save-profile-picture'
      this.headers = {'Authorization': 'Bearer ' + this.state.token}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/EditProfile.vue